import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {
  TABS_DEFAULTS,
  TABS_VARIANT_CLASS_MAP,
  type TTabsContentElement,
  type TTabsContentProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { cn } from "@/ui/lib/utils";

export const TabsContent = forwardRef<TTabsContentElement, TTabsContentProps>(
  (
    {
      variant = TABS_DEFAULTS.variant,
      className,
      ...props
    },
    ref,
  ) => (
    <TabsPrimitive.Content
      data-component="TabsContent"
      ref={ref}
      className={cn(
        "py-2",
        TABS_VARIANT_CLASS_MAP[variant].content,
        className,
      )}
      {...props}
    />
  ),
);

TabsContent.displayName = TabsPrimitive.Content.displayName;
